import { useGetUser } from '../api/user/user.ts'
import { useClarity } from '../hooks/useClarity.ts'
import { useErrorNotifier } from '../hooks/useErrorNotifier.tsx'
import { useSleekPlan } from '../hooks/useSleekPlan.ts'
import { LayoutComponent } from './LayoutComponent.tsx'
import { LoadingComponent } from './common/LoadingComponent.tsx'

export const Base = () => {
    const { data: userInfo } = useGetUser()
    const { contextHolder } = useErrorNotifier()
    useClarity()
    useSleekPlan()

    return !userInfo ? <LoadingComponent /> : <>{contextHolder}<LayoutComponent /></>
}
